export default __webpack_public_path__ + "2afd0475412173e6904c5169e14ee95f.png";